export default "__VITE_ASSET__CcGFTSX$__"